import React, { useState } from 'react'
import Debug from 'debug'
import { AuthPage } from './AuthPage'
import { Form, Field } from 'react-final-form'
import { Link } from 'react-router-dom'
import { DIGITS, UPPER, LOWER, PUNCT } from 'suredone-common'
import { FormGroup, FormFeedback, Input, Button, Row, Col, Label } from 'reactstrap'
import { FaSignOutAlt as LogOut } from 'react-icons/fa'
import { observer } from 'mobx-react'
import { useStores } from '../../stores/RootStore'
import { ErrorAlert, Loading, SaveButton } from '../../components'
const debug = Debug('sd:ForceChangePassword')

const PasswordForm = (props) => {
  const { handleSubmit, submitting, pristine, hasValidationErrors, values, customError, setCustomError, submitSucceeded } = props
  return (
    <>
      {submitting ? <Loading /> : null}
      <form className='auth-form' onSubmit={handleSubmit}>
        <Label className='mb-3'>Please enter a new password</Label>

        <Row>
          <Col>
            <FormGroup>
              <div className='form-label-group'>
                <Field
                  name='password'
                  validate={password => {
                    if (!password) return 'Password is required'
                    if (!DIGITS.test(password)) return 'Password must contain one or more digits.'
                    if (!UPPER.test(password)) return 'Password must contain one or more uppercase letters.'
                    if (!LOWER.test(password)) return 'Password must contain one or more lowercase letters.'
                    if (!PUNCT.test(password)) return 'Password must contain one or more punctuation characters.'
                  }}
                >
                  {({ input, meta }) => (
                    <>
                      <Input
                        {...input}
                        autoFocus
                        type='password'
                        id='password'
                        valid={meta.valid}
                        invalid={meta.touched && meta.invalid}
                        placeholder='Password'
                        autoComplete='off'
                      />
                      <Label for='password'>Password</Label>
                      {meta.error && meta.touched && <FormFeedback>{meta.error}</FormFeedback>}
                    </>
                  )}
                </Field>
              </div>
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup>
              <div className='form-label-group'>
                <Field
                  name='password2'
                  validate={password2 => {
                    if (!password2) return 'Password confirmation is required'
                    if (values.password !== password2) return 'Passwords don\'t match'
                  }}
                >
                  {({ input, meta }) => (
                    <>
                      <Input
                        {...input}
                        type='password'
                        id='password2'
                        placeholder='Confirm password'
                        valid={meta.valid}
                        invalid={meta.touched && meta.error}
                        autoComplete='off'
                      />
                      <Label for='password2'>Confirm password</Label>
                      {meta.error && meta.touched && <FormFeedback>{meta.error}</FormFeedback>}
                    </>
                  )}
                </Field>
              </div>
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          {customError && <ErrorAlert isOpen={customError} toggle={() => setCustomError(false)} error={customError} />}
          <SaveButton
            color='primary'
            type='submit'
            block
            loading={submitting}
            disabled={submitting || pristine || hasValidationErrors}
            // The following sintax {state ? 'true' : false} is to avoid console warnings
            success={submitSucceeded}
          >
            Change password
          </SaveButton>
        </FormGroup>
      </form>
    </>
  )
}

const _ForceChangePassword = (props) => {
  const { stores: { auth } } = useStores()
  const { cognitoUser } = auth || {}
  const { username } = cognitoUser || {}
  const [customError, setCustomError] = useState()
  const NewPasswordForm = () => {
    const onHandleSubmit = async (values) => {
      const { password } = values
      try {
        await auth.forceChangePassword(username, password)
      } catch (error) {
        setCustomError(error)
      }
    }

    return (
      <Form
        onSubmit={onHandleSubmit}
        setCustomError={setCustomError}
        customError={customError}
      >
        {props => <PasswordForm {...props} />}
      </Form>
    )
  }
  return (
    <AuthPage
      form={<NewPasswordForm />}
      footer={
        <Button tag={Link} color='link' to='/' onClick={_ => auth.logOut()}>
          <LogOut /> Log Out
        </Button>
      }
    />
  )
}

const ForceChangePassword = observer(_ForceChangePassword)

export { ForceChangePassword }

debug('loaded')
